module.exports = __webpack_public_path__ + "img/so.bc593c33.svg";